import Client from '../client';
import { AxiosResponse } from 'axios';
import BaseService from '../baseService/baseService';

const ParametroJurosFinanciamentoService = 
{
    deletarExcelParametros(fileRequest: any)
    {
        return BaseService.conectarEndpoint(fileRequest, 'jurosFinanciamento/excel/deletar', 'excelJurosFinanciamentoDeletar');
    },
    enviarExcelParametros(fileRequest: any)
    {
        return BaseService.conectarEndpoint(fileRequest, 'jurosFinanciamento/excel', 'excelJurosFinanciamento');
    },
    obterExcel(): Promise<void | AxiosResponse<any>> 
    {
        return Client.getBlob('jurosFinanciamento/excel');
    },
    enviarParametrosAoEventGrid(): Promise<void | AxiosResponse<any>> 
    {
        return Client.post('jurosFinanciamento/eventGrid', {});
    }
}

export default ParametroJurosFinanciamentoService;